export default {
  cheap: {
    disabledDates: [
      new Date(2022,11,25),
      new Date(2022,11,30),
      new Date(2022,11,31),
      new Date(2023,0,1),
    ]
  },
  develop: {
    disabledDates: [
      new Date(2021,11,24),
      new Date(2021,11,25),
      new Date(2021,11,26),
    ]
  }
}
